module.exports = __webpack_public_path__ + "img/face-smile-beam.43934df8.svg";